const appConfig = {
    default_language: "zh-CN",
    toLinkZoom: {
        toPCLinkZH: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1534422131015831554&type=2',
        toPCLinkEN: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1567425419948584961&type=2',
        toPCLinkJP: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1567425420070219777&type=2',
        toMobileLinkZH: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1564795304975069185',
        toMobileLinkEN: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1567405747327426561&type=2',
        toMobileLinkJP: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1567406270042562561&type=2',
    },
    toLinkTM: {
        toMXBrowserLink: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1613722559163478017&type=2',        // 内部环境打开操作详情指引
        toOtherBrowserLink: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1613722722355458049&type=2',     // 外部环境打开操作详情指引
    },
    toGaoAnLink: 'https://mapmpm5.midea.com/newservicenopages/#/content/preview?id=1610950741728251906&type=2',
    toDownloadMX: 'https://im.midea.com/download/pcv5.html',
    toDownloadTXMeeting: 'https://meeting.tencent.com/download?mfrom=OfficialIndex_TopBanner1_Download',
    toDownloadVooV: 'https://voovmeeting.com/download-center.html?from=1001',
}

window.PROJECT_CONFIG && Object.assign(appConfig, window.PROJECT_CONFIG)
window.PACKAGE_CONFIG && Object.assign(appConfig, { packageConfig: window.PACKAGE_CONFIG })

export default appConfig
